/**
 * 라인시트세트 조회 실패가 '존재하지 않음(404)' 또는 '접근 불가(403, 삭제/미발행/미배정)' 인지 판정한다.
 * (해당 세트에 바이어가 바로 접속한 경우 → 에러 토스트 대신 '존재하지 않는 라인시트' 안내 페이지로 보낸다)
 *
 * uno-axios 응답 인터셉터가 에러를 { error: { code, status, message } } 형태로 throw 하므로
 * error.error.code 를 우선 확인하고, 혹시 raw AxiosError 가 넘어오는 경로를 대비해 response.status 도 함께 본다.
 */
export function isLineSheetSetUnavailableError(error: any): boolean {
  const code =
    error?.error?.code ??
    error?.response?.status ??
    error?.response?.data?.error?.code;
  return code === 404 || code === 403;
}
